import { roundQuantity } from '@obraplan/core/domain/schedule/unit-of-measure';
import type { TeamFrontView } from '@obraplan/core/application/contracts/team-measurement';

/**
 * Como a medição da equipe se escreve na tela (Fase 30, etapa 1).
 *
 * Fora dos componentes por dois motivos: o painel e o diálogo dizem as mesmas coisas com as
 * mesmas palavras, e um arquivo que exporta componente e função perde o recarregamento a quente.
 */

type UnidadeDaFrente = NonNullable<TeamFrontView['unit']>;

/** `"1.250,500 kg"` — a quantidade na precisão da unidade; sem unidade, só o número. */
export function formatTeamQuantity(
  value: number,
  unit: Pick<UnidadeDaFrente, 'name' | 'decimals'> | undefined,
): string {
  const decimals = unit?.decimals ?? 3;
  const texto = roundQuantity(value, decimals).toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return unit === undefined ? texto : `${texto} ${unit.name}`;
}

/** `"14:32"` — a hora da medição, no fuso do aparelho de quem olha. */
export function formatMeasuredTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

/** `"Medida: 1.200,000 kg por Fulano às 14:32"` — quem mediu fica de fora se o servidor não disse. */
export function describeTeamMeasurement(
  measurement: NonNullable<TeamFrontView['measurement']>,
  unit: UnidadeDaFrente | undefined,
): string {
  const quem = measurement.measuredByName === undefined ? '' : ` por ${measurement.measuredByName}`;
  return `Medida: ${formatTeamQuantity(measurement.quantity, unit)}${quem} às ${formatMeasuredTime(measurement.measuredAt)}`;
}
